import { getCurrentWebUserIdToken } from "./firebaseWeb";

const SIGNUP_PROFILE_ENDPOINT = "/api/signup-profile";

async function parseJsonResponse(response, fallbackMessage) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok === false) {
    const error = new Error(data.message || fallbackMessage);
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
}

export async function checkNicknameAvailabilityViaApi(nickname) {
  const search = new URLSearchParams({ nickname: String(nickname || "") });
  const response = await fetch(`${SIGNUP_PROFILE_ENDPOINT}?${search.toString()}`, {
    headers: { Accept: "application/json" },
  });
  return parseJsonResponse(response, "Kullanıcı adı kontrol edilemedi.");
}

export async function completeSignupProfileForCurrentUser({ nickname, legalConsent } = {}) {
  const token = await getCurrentWebUserIdToken(true);
  if (!token) throw new Error("Kayıt profilini tamamlamak için oturum gerekiyor.");
  const response = await fetch(SIGNUP_PROFILE_ENDPOINT, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ action: "complete", nickname, legalConsent }),
  });
  return parseJsonResponse(response, "Kayıt profili tamamlanamadı.");
}

export async function syncAccountProfileViaApi() {
  const token = await getCurrentWebUserIdToken(true);
  if (!token) throw new Error("Hesap profilini yenilemek için oturum gerekiyor.");
  const response = await fetch(SIGNUP_PROFILE_ENDPOINT, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ action: "sync" }),
  });
  return parseJsonResponse(response, "Hesap profili yenilenemedi.");
}
